module.exports = __webpack_public_path__ + "static/media/cancelblack.cecbf7bf.svg";